import React from 'react';
import ProductMockup from './ProductMockup';
import StoreCtaButtons from './StoreCtaButtons';
import { useRevealInView, useScrollParallaxVar } from '../lib/landingMotion';

const heroTitleLines = ['Precision.', 'Progress.', 'Consistency.'];

export default function HeroSection() {
    const { ref, isVisible, prefersReducedMotion } = useRevealInView({
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
    });
    const backParallaxRef = useScrollParallaxVar({
        property: '--parallax-y',
        distance: 14,
        reducedMotion: prefersReducedMotion,
    });
    const frontParallaxRef = useScrollParallaxVar({
        property: '--parallax-y',
        distance: 26,
        reducedMotion: prefersReducedMotion,
    });

    return (
        <section
            ref={ref}
            className={`landing-section landing-hero ${isVisible ? 'is-visible' : ''}`}
            id="top"
            data-reveal-root
        >
            <div className="site-container landing-hero__grid">
                <div className="landing-hero__copy">
                    <h1 className="landing-hero__title" aria-label={heroTitleLines.join(' ')}>
                        {heroTitleLines.map((line, index) => (
                            <span
                                key={line}
                                className="landing-hero__title-line"
                                style={{ '--delay': `${index * 90}ms` }}
                            >
                                {line}
                            </span>
                        ))}
                    </h1>

                    <p className="landing-hero__description" data-reveal-item style={{ '--delay': '90ms' }}>
                        Stop Adapting your Training to your app. Most fitness apps force you into rigid
                        templates. TECNIQ adapts to you.
                    </p>

                    <div className="landing-hero__actions" data-reveal-item style={{ '--delay': '170ms' }}>
                        <StoreCtaButtons variant="hero" />
                    </div>
                </div>

                <div className="landing-hero__visual">
                    <div className="landing-hero__phones">
                        <div className="landing-phone landing-phone--hero-back" data-reveal-item style={{ '--delay': '220ms' }}>
                            <div ref={backParallaxRef} className="landing-phone__parallax">
                                <ProductMockup
                                    asset="heroAnalytics"
                                    loading="eager"
                                    alt="TECNIQ analytics overview preview"
                                    objectFit="contain"
                                />
                            </div>
                        </div>

                        <div className="landing-phone landing-phone--hero-front" data-reveal-item style={{ '--delay': '130ms' }}>
                            <div ref={frontParallaxRef} className="landing-phone__parallax">
                                <ProductMockup
                                    asset="heroWorkout"
                                    loading="eager"
                                    alt="TECNIQ workout logging preview"
                                    objectFit="contain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
